export default {
  CREATE: `Créer un groupe de permission`,
  DELETE_BUTTON: {
    TITLE: `Supprimer le groupe de permission`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer ce groupe de permission?`,
    PRIMARY_ACTION: `Supprimer le groupe de permission`
  },
  LIST: {
    TITLE: `Liste des groupes de permission`
  },
  IS_DEFAULT: `Par défaut`,
  PROFILE: `Mon profile`,
  SHOW_DAILY: `Mon horaire`,
  SHOW_WEEKLY: `Vue par semaine`,
  MINE: `Accueil`,
  SHOW_PROJECT_CALENDAR: `Vue par projet`,
  LEAVE: `Liste des absences`,
  MY_TIME_OFF: `Mes congés`,
  MY_ATTENDANCE: `Mes absences`,
  TIME_OFF: `Liste des congés`,
  BULLETINS: `Babillard`,
  PROJECTS: `Projets`,
  REPORT: `Rapports`,
  REVOKE: `Révoquer`,
  API_TOKEN: `Jeton d'API`,
  ISSUER: `Émetteur`,
  INFORMATION: `Information`,
  apiToken: {
    TITLE: `Liste des jetons d'API`,
    PRIMARY_ACTION: `Émettre un nouveau jeton`,
    SUMMARY: ``
  },
  newToken: {
    TITLE: `Nouveau jeton d'API`,
    SUMMARY: ``
  },
  ADMIN: {
    TITLE: `Modules et permissions permises pour cette compagnie.`,
    SUMMARY: ``,
    SELECT_ALL: `Tout sélectionner`,
    UNSELECT_ALL: `Tout désélectionner`
  },
  form: {
    TYPE: {
      LABEL: `Type d'utilisateur`,
      DESCRIPTION: ``
    },
    CREATE: {
      TITLE: `Création d'un groupe de permissions`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modication d'un groupe de permissions`,
      SUMMARY: ``
    },
    NAMEFR: {
      LABEL: `Nom français du groupe de permissions`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom pour le groupe de permissions`
    },
    NAMEEN: {
      LABEL: `Nom anglais du groupe de permissions`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom pour le groupe de permissions`
    },
    IMPORTCODE: {
      LABEL: `Code d'import`,
      DESCRIPTION: `Le code d'importation sert à assigner des groupes de permission aux utilisateurs avec les outils d'importation.`,
      PLACEHOLDER: `Entrez le code d'importation`
    },
    ISDEFAULT: {
      LABEL: `Permission par défaut`,
      DESCRIPTION: `Sera ajouté par défaut à tous les nouveaux utilisateurs.`
    },
    ENABLECHAT: {
      LABEL: `Activer le chat`,
      DESCRIPTION: `Permettra aux utilisateurs de ce groupe d'utiliser la messagerie.`
    },
    LIMITTOREPORTSTO: {
      LABEL: `Peut voir seulement ses projets/équipes`,
      DESCRIPTION: `Empêchera les utilisateurs étant dans ce groupe à avoir accès à toutes les requêtes/utilisateurs de la compagnie.`
    },
    RESTRICTTOPUNCHTERMINAL: {
      LABEL: `Restreindre au terminal de poinçonnage`,
      DESCRIPTION: `L'utilisateur n'aura accès qu'au terminal de poinçonnage.`
    },
    DEFAULTREPORTSTO: {
      LABEL: `Se rapporte par défaut`,
      DESCRIPTION: `Utilisé pour déterminer la vue par défaut dans l'horaire.`,
      NONE: `Aucun`,
      TEAM: `Équipe`,
      PROJECT: `Projet`
    },
    NAME_REQUIRED: `Le nom du groupe de permissions est obligatoire.`
  },
  permissionsKey: {
    MONTHLY_VIEW: 'Vue mensuelle',
    WEEKLY_VIEW: 'Vue hebdomadaire',
    DAILY_VIEW: 'Vue journalière',
    LIST_CREATION: 'Création de liste',
    GROUPED_LIST_CREATION: 'Création de liste groupée',
    SCHEDULE_SEE_OTHERS: `Voir l'horaire complet`,
    SCHEDULE_SEE_COWORKERS: `Voir les quarts des collègues`,
    SHIFT_CREATION: 'Création de quarts de travail',
    SHIFT_MODIFICATION: 'Modification de quarts de travail',
    SHIFT_DELETION: 'Suppression de quarts de travail',
    SHIFT_CANCELLATION: 'Annulation de quarts de travail',
    SHIFT_PUBLISHING: 'Publication de quarts de travail',
    ASSIGN_EMPLOYEE: "Assignation d'un employé à un quart de travail",
    QUICK_ASSIGN: 'Assignation rapide',
    BULK_CHANGES_CREATE: 'Changement multiple - Création',
    BULK_CHANGES_EDIT: 'Changement multiple - Modification',
    BULK_CHANGES_DELETE: 'Changement multiple - Suppression',
    SCHEDULE_TEMPLATE_CREATION: "Création de modèles d'horaire",
    SCHEDULE_TEMPLATE_APPLICATION: "Application de modèles d'horaire",
    SEE_SHIFT_HISTORY: "Voir l'historique des quarts de travail",
    SEE_LEAVE: 'Voir les absences',
    SEE_LEAVE_OTHERS: 'Voir les absences des autres utilisateurs',
    CREATE_LEAVE: 'Créer des absences',
    CREATE_LEAVE_OTHERS: 'Créer des absences pour les autres utilisateurs',
    UPDATE_LEAVE: 'Modifier des absences',
    DELETE_LEAVE: 'Supprimer des absences',
    CANCEL_LEAVE: 'Annuler des absences',
    APPROUVE_LEAVE: 'Approuver des absences',
    UNAPPROUVE_LEAVE: 'Désapprouver des absences',
    EXPORT_LEAVE: 'Exporter des absences',
    SEE_TIME_OFF: 'Voir les congés',
    SEE_TIME_OFF_OTHERS: 'Voir les congés des autres utilisateurs',
    CREATE_TIME_OFF: 'Créer des congés',
    CREATE_TIME_OFF_OTHERS: 'Créer des congés pour les autres utilisateurs',
    UPDATE_TIME_OFF: 'Modifier des congés',
    DELETE_TIME_OFF: 'Supprimer des congés',
    CANCEL_TIME_OFF: 'Annuler des congés',
    APPROUVE_TIME_OFF: 'Approuver des congés',
    UNAPPROUVE_TIME_OFF: 'Désapprouver des congés',
    EXPORT_TIME_OFF: 'Exporter les congés',
    TIME_OFF_CALENDAR_VIEW: 'Vue mensuelle des congés',
    SEE_ATTRIBUTE: 'Voir les attributs',
    CREATE_ATTRIBUTE: 'Créer des attributs',
    UPDATE_ATTRIBUTE: 'Modifier des attributs',
    DELETE_ATTRIBUTE: 'Supprimer des attributs',
    ASSIGN_ATTRIBUTE: 'Assigner un attribut',
    UNASSIGN_ATTRIBUTE: 'Désassigner un attribut',
    SEE_FILE: 'Voir les fichiers',
    ADD_FILE: 'Ajouter des fichiers',
    REMOVE_FILE: 'Supprimer des fichiers',
    RENEW_ATTRIBUTE: 'Renouveler un attribut',
    PROMOTE_ATTRIBUTE: 'Promouvoir un attribut',
    DOWN_GRADE_ATTRIBUTE: 'Rétrograder un attribut',
    SEE_DEPARTMENTS: 'Voir les départements',
    CREATE_DEPARTMENTS: 'Créer des départements',
    UPDATE_DEPARTMENTS: 'Modifier des départements',
    ASSIGN_DEPARTMENT: 'Assigner des départements',
    UNASSIGN_DEPARTMENT: 'Désassigner des départements',
    DELETE_DEPARTMENTS: 'Supprimer des départements',
    SEE_POSITION_TYPE: 'Voir les types de position',
    CREATE_POSITION_TYPE: 'Créer des types de position',
    UPDATE_POSITION_TYPE: 'Modifier des types de position',
    DELETE_POSITION_TYPE: 'Supprimer des types de position',
    SEE_STRUCTURE: 'Voir la structure',
    CREATE_STRUCTURE: 'Créer des structures',
    UPDATE_STRUCTURE: 'Modifier des structures',
    ORDER_STRUCTURE: 'Ordonner la structure',
    DELETE_STRUCTUREL: 'Supprimer des structures',
    SEE_USER: 'Voir les utilisateurs',
    CREATE_USER: 'Créer des utilisateurs',
    UPDATE_USER: 'Modifier des utilisateurs',
    UPDATE_USER_PERSONNAL_INFO: 'Modifier les informations personnelles des utilisateurs',
    DELETE_USER: 'Supprimer des utilisateurs',
    APPLICATION_SETTING: "Modification des paramètres de l'application",
    SEE_REPORT: 'Voir les rapports',
    SEE_PERMISSIONS_GROUP: 'Voir les groupes de permissions',
    CREATE_PERMISSIONS_GROUP: 'Créer des groupes de permissions',
    UPDATE_PERMISSIONS_GROUP: 'Modifier des groupes de permissions',
    DELETE_PERMISSIONS_GROUP: 'Supprimer des groupes de permissions',
    ASSIGN_PERMISSIONS_GROUP: 'Assigner des groupes de permissions',
    UNASSIGN_PERMISSIONS_GROUP: 'Désassigner des groupes de permissions',
    SEE_REPLACEMENT_LIST: 'Voir les listes de remplacements',
    REPORT_REPLACEMENT_LIST: 'Rapport dans les listes de remplacements',
    START_REPLACEMENT_LIST: 'Démarrer les listes de remplacements',
    USE_REPLACEMENT_LIST: 'Utiliser les listes de remplacements',
    NOTIFICATION_REPLACEMENT_LIST: 'Notification dans les listes de remplacements',
    DELETE_REPLACEMENT_LIST: 'Supprimer des listes de remplacements',
    ARCHIVE_REPLACEMENT_LIST: 'Archiver des listes de remplacements',
    APPROUVE_REPLACEMENT_LIST: 'Approuver des listes de remplacements',
    UNAPPROUVE_REPLACEMENT_LIST: 'Désapprouver des listes de remplacements',
    VIEW_MESSAGES_IN_APP: "Voir et accepter des quarts de travail à partir de l'application",
    SCHEDULE_CONFIRMATION: "Envoyer des demandes de confirmation d'horaire",
    SEE_PROJECT: 'Voir les projets',
    CREATE_PROJECT: 'Créer des projets',
    UPDATE_PROJECT: 'Modifier des projets',
    DELETE_PROJECT: 'Supprimer des projets',
    SEE_AVAILABILITIES: 'Voir ses disponibilités',
    EDIT_AVAILABILITIES: 'Modifier ou supprimer ses disponibilités',
    APPROVE_AVAILABILITY: 'Approuver des disponibilités',
    REQUEST_CHANGE_AVAILABILITY: 'Demander des changements de disponibilité',
    REQUEST_TEMPORARY_AVAILABILITY: 'Demander une disponibilité temporaire',
    BULLETIN: 'Babillard',
    IMPORT_USER: 'Importer des utilisateurs',
    IMPORT_CLIENT: `Importer les clients`,
    IMPORT_PROJECT: `Importer les projets`,
    HIRING_DATA: "Données d'embauche",
    SEE_HIRING_DATA: "Voir les données d'embauche",
    CREATE_HIRING_DATA: "Créer des données d'embauche",
    UPDATE_HIRING_DATA: "Modifier des données d'embauche",
    DELETE_HIRING_DATA: "Supprimer des données d'embauche",
    MANAGE_PROJECT_CLIENTS: "Gérer les clients d'un projet",
    SEE_FILTERS: 'Voir les filtres',
    MANAGE_FILTERS: 'Gérer des filtres',
    SEE_AUDIT: "Voir les rapports d'audit",
    SEE_AUDIT_OTHERS: "Voir les rapports d'audit des autres utilisateurs",
    CREATE_REQUESTS_FIELDS: 'Créer des types de requêtes',
    MANAGE_REQUESTS_FIELDS: 'Gérer des types de requêtes',
    DELETE_REQUESTS_FIELDS: 'Supprimer des types de requêtes',
    UPDATE_REQUESTS_FIELDS: 'Modifier des types de requêtes',
    CONFIRM_DELETE_GROUP: 'Êtes-vous certain(e) de vouloir supprimer ce groupe?',
    SCHEDULE_PERMISSION_GROUP: 'Horaire',
    LEAVE_PERMISSION_GROUP: 'Absences',
    TIME_OFF_PERMISSION_GROUP: 'Congés',
    REPLACEMENT_LIST_PERMISSION_GROUP: "Listes d'appel",
    ATTRIBUTES_PERMISSION_GROUP: `Attributs`,
    DEPARTMENTS_PERMISSION_GROUP: 'Départements',
    STRUCTURE_PERMISSION_GROUP: 'Structure',
    USER_PERMISSION_GROUP: `Utilisateurs`,
    PERMISSIONS_PERMISSION_GROUP: 'Gestion des permissions',
    SETTINGS_PERMISSION_GROUP: 'Configurations',
    REPORTS_PERMISSION_GROUP: 'Rapports',
    AVAILABILITIES_PERMISSION_GROUP: 'Disponibilités',
    BULLETIN_PERMISSION_GROUP: 'Babillard',
    HIRING_DATA_PERMISSION_GROUP: "Données d'embauche",
    PROJECTS_PERMISSION_GROUP: 'Projets',
    REQUEST_FIELDS_PERMISSION_GROUP: 'Champs de requêtes',
    AUDIT_PERMISSION_GROUP: "Rapports d'audit",
    FILTERS_PERMISSION_GROUP: 'Filtres',
    VACATION_DISTRIBUTION_PERMISSION_GROUP: 'Distribution de vacances',
    SEE_VACATION_DISTRIBUTION: 'Voir les distributions de vacances',
    CREATE_VACATION_DISTRIBUTION: 'Créer des distributions de vacances',
    UPDATE_VACATION_DISTRIBUTION: 'Mettre à jour des distributions de vacances',
    DELETE_VACATION_DISTRIBUTION: 'Supprimer des distributions de vacances',
    MAKE_CHOICES_VACATION_DISTRIBUTION: 'Faire des choix dans une distribution de vacances',
    SEE_OTHERS_CHOICES_VACATION_DISTRIBUTION: 'Voir les choix des autres utilisateurs dans une distribution de vacances',
    UPDATE_OTHERS_CHOICES_VACATION_DISTRIBUTION: 'Mettre à jour les choix des autres utilisateurs dans une distribution de vacances',
    FORCE_OTHERS_CHOICES_VACATION_DISTRIBUTION: "Forcer le choix d'un utilisateur pour qu'il soit valide dans une distribution de vacances",
    IMPORT_CONFIG_PERMISSION_GROUP: "Module d'importation",
    SEE_IMPORT_CONFIG: 'Voir les configurations',
    UPDATE_IMPORT_CONFIG: 'Mettre à jour des configurations',
    CREATE_IMPORT_CONFIG: 'Créer des configurations',
    DELETE_IMPORT_CONFIG: 'Supprimer des configurations',
    UPDATE_USER_HIRING_INFO: "Modifier les informations d'embauche d'un utilisateur",
    UPDATE_USER_CONTACT_INFO: "Modifier les informations de contact d'un utilisateur",
    UPDATE_USER_CONNECTION_INFO: "Modifier les informations de connexion d'un utilisateur",
    SHIFT_SWAP_PERMISSION_GROUP: 'Échanges de quarts de travail',
    CAN_CONFIRM_SWAP: 'Confirmer un échange de quarts de travail',
    SHIFT_SWAP_SEE_OTHERS: 'Voir les échanges de quarts de travail des autres utilisateurs',
    DELETE_SHIFT_SWAP: 'Supprimer des échanges de quarts de travail',
    API_TOKEN: "Jeton d'API",
    API_TOKEN_MODAL: "Gestion des jetons d'API pour le groupe de permissions : ",
    ISSUER: 'Émetteur',
    INFORMATION: 'Information',
    ISSUE_NEW_TOKEN: 'Émettre un nouveau jeton',
    REVOKE: 'Révoquer',
    TAGS_PERMISSION_GROUP: 'Étiquettes',
    HOLIDAYS_PERMISSION_GROUP: `Jours fériés`,
    SEE_TAGS: 'Voir les étiquettes',
    CREATE_TAGS: 'Créer des étiquettes',
    UPDATE_TAGS: 'Modifier des étiquettes',
    DELETE_TAGS: 'Supprimer des étiquettes',
    MANAGE_HOLIDAYS: 'Gérer les jours fériés',
    STATISTICS_PERMISSION_GROUP: 'Statistiques',
    SEE_STATISTICS: 'Voir les statistiques',
    IMPORT_ATTRIBUTE: 'Importer des attributs',
    IMPORT_PERMISSION_GROUP: 'Importation',
    USER_PROCEDURES_PERMISSION_GROUP: 'Procédures',
    SEE_PROCEDURES: 'Voir les procédures',
    MANAGE_PROCEDURES: 'Gérer des procédures',
    USER_SORTS_PERMISSION_GROUP: 'Ordonnancements',
    SEE_SORTS: 'Voir les ordonnancements',
    MANAGE_SORTS: 'Gérer des ordonnancements',
    USER_FILTERS_PERMISSION_GROUP: 'Filtre',
    GENERATE_API_TOKEN: "Générer des jetons d'API",
    SEND_ONBOARDING_LINK: "Envoyer des courriels d'invitation",
    CONTACT_LIST_PERMISSION_GROUP: 'Listes de contacts',
    SEE_CONTACT_LIST: 'Voir les listes de contacts',
    DELETE_CONTACT_LIST: 'Supprimer des listes de contacts',
    APPROUVE_CONTACT_LIST: 'Approuver des listes de contacts',
    NOTIFICATION_CONTACT_LIST: 'Notification des listes de contacts',
    ARCHIVE_CONTACT_LIST: 'Archiver des listes de contacts',
    UNAPPROUVE_CONTACT_LIST: 'Désapprouver des listes de contacts',
    CONTROL_CONTACT_LIST: 'Gérer des listes de contacts',
    SEE_SCHEDULE_CAPACITY: "Voir et calculer la capacité d'horaire",
    SEE_USER_PERSONNAL_INFO: 'Voir les informations personnelles des utilisateurs',
    SEE_USER_HIRING_INFO: "Voir les données d'embauche des utilisateurs",
    SEE_USER_CONTACT_INFO: 'Voir les informations de contact des utilisateurs',
    SEE_USER_CONNECTION_INFO: 'Voir les informations de connexion des utilisateurs',
    SEE_USER_PAY_INFO: `Voir les informations de paie des utilisateurs`,
    SEE_OTHERS_AVAILABILITIES: 'Voir les disponibilités des autres utilisateurs',
    EDIT_OTHERS_AVAILABILITIES: 'Modifier les disponibilités des autres utilisateurs',
    IMPORT_STRUCTURE: 'Importer des structures',
    IMPORT_SCHEDULE: 'Importer des quarts de travail',
    IMPORT_VACATION: 'Importer des vacances',
    IMPORT_DISPONIBILITY: 'Importer des disponibilités',
    IMPORT_ATTRIBUTE_ASSIGNATION: `Importer des assignations d'attribut`,
    SCHEDULE_SEE_MINE: 'Voir mon horaire',
    CAN_SWAP_OTHERS: "Échanges de quarts de travail d'autres utilisateurs",
    VIEW_CONTACT_REPORTS: 'Voir le rapport de contact',
    BREAKS_PERMISSION_GROUP: 'Pauses',
    SEE_BREAKS: 'Voir les pauses',
    CREATE_BREAKS: 'Créer des pauses',
    UPDATE_BREAKS: 'Modifier des pauses',
    DELETE_BREAKS: 'Supprimer des pauses',
    COMMENTS: 'Commentaires',
    ATTACHMENTS: `Pièces jointes`,
    CONTACT_PERMISSION_GROUP: 'Contacts',
    BOOST_CONTACT: "Augmenter/Diminuer le nombre d'appels simultanés",
    SEE_BULLETIN: 'Voir le babillard',
    SEE_READ_BY_BULLETIN: 'Voir les utilisateurs ayant lu une annonce',
    MANAGE_BULLETIN: 'Gérer mes annonces',
    MANAGE_OTHERS_BULLETIN: 'Gérer les annonces des autres utilisateurs',
    SEND_BULLETIN_NOTIFICATIONS: 'Envoyer des notifications de babillard',
    CONTACT_LIST_CONFIGS_PERMISSION_GROUP: 'Configuration des listes de contacts',
    CREATE_CONFIGS: 'Créer des configurations',
    UPDATE_CONFIGS: 'Modifier les configurations',
    DELETE_CONFIGS: 'Supprimer des configurations',
    ARCHIVE_USER: "Archiver l'utilisateur",
    SEE_DIFF: "Voir l'historique des modifications d'un utilisateur",
    PUNCHCARDS_PERMISSION_GROUP: 'Cartes de temps',
    SEE_PUNCHCARDS: 'Voir les cartes de temps',
    PUNCHTERMINAL_PERMISSION_GROUP: 'Terminal de poinçonnage',
    START_PUNCH_TERMINAL: 'Lancer une session de poinçonnage',
    PUNCH_ON_SHIFTS: 'Poinçonner sur ses propres quarts',
    SEE_OWN_PUNCHES: 'Voir ses propres poinçons',
    DELETE_PUNCHCARDS: 'Supprimer des cartes de temps',
    MODIFY_PUNCHCARDS: 'Modifier/Créer des cartes de temps',
    MODIFY_LOCKED_PUNCHCARDS: 'Modifier/Créer des cartes de temps vérouillées',
    CHANGE_PUNCH_LOCK: 'Modifier la date de vérouillage',
    ENABLE_APPROVE_OWN_PUNCH_CARD: 'Approuver ses propres cartes de temps',
    TEAMS: 'Équipes',
    TEAMS_PERMISSION_GROUP: 'Équipes',
    MODIFY_TEAMS: 'Modifier des équipes',
    DELETE_TEAMS: 'Supprimer des équipes',
    PUNCHRULES_PERMISSION_GROUP: 'Règles de cartes de temps',
    MANAGE_PUNCH_RULES: 'Gérer des règles de cartes de temps',
    SEE_TIME_OFF_PAGE: 'Voir la page de vacances',
    UPDATE_REPLACEMENT_STATUS: 'Mettre à jour le statut de remplacement',
    PROFILE_PERMISSION_GROUP: "Profil de l'employé",
    UPDATE_PHONE_NUMBERS: 'Mettre à jour les numéro de téléphone',
    UPDATE_CONTACT_EMAILS: 'Mettre à jour les courriels de contact',
    FINALIZE_SHIFT: 'Finaliser les quarts de travail',
    MANAGE_SPECIFIC_RESTRICTIONS: 'Voir les restrictions',
    SCHEDULE_TYPES_PERMISSION_GROUP: "Types d'horaire",
    MANAGE_SCHEDULE_TYPES: "Gérer les types d'horaire",
    PAY_PERMISSION_GROUP: 'Paie',
    MANAGE_WAGE_PREMIUM: 'Gérer les codes de primes',
    OVERRIDE_WAGE_PREMIUM: 'Permettre de désactiver le calcul automatique des primes de temps supplémentaire',
    SEE_COMMENTS_OTHERS: `Voir les commentaires des autres utilisateurs `,
    BACK_TO_PERMISSIONS_MGMT: 'Retourner à gestion des permissions',
    LIST_CONFIG_PERMISSION_GROUP: `Configuration des listes, de l'horaire, des filtres, etc.`,
    SEE_LIST_CONFIGS: 'Voir les configurations',
    MANAGE_LIST_CONFIGS: 'Gérer les configurations',
    CONTACT_LOGS_PERMISSION_GROUP: "Page d'audit des listes de contacts",
    SEE_CONTACT_LOGS: "Voir l'audit des listes de contacts",
    CAN_SEE_MODULE: 'Peut voir le module',
    MANAGE_PERMISSIONS_GROUP: 'Gérer les groupes de permissions',
    SEE_SCHEDULE_ISSUES: "Voir la page des problèmes d'horaire",
    ALLOWED_PERMISSIONS: 'Permissions permises',
    MODIFY_ALLOWED_PERMISSIONS: "Modifier les permissions permises d'une entreprise",
    POSITIONS: 'Positions',
    CREATE_GROUP: 'Créer un groupe de permission',
    DEFAULT_PATH: 'Page par défaut',
    DEFAULT_PATH_DESC: "Page affiché par défaut lorsqu'un utilisateur se connecte",
    PATH_PRIORITY: 'Priorité de la page',
    PATH_PRIORITY_DESC: "Priorité de la page par défaut (Utile lorsqu'un utilisateur possède plusieurs groupes de permission)",
    DEFAULT_HELP_URL: "Article d'aide",
    DEFAULT_HELP_URL_DESC: "Lorsqu'un utilisateur clic sur (?), celui-ci sera amené à cette article.",
    HELP_URL_PRIORITY: "Priorité de l'article",
    HELP_URL_PRIORITY_DESC: "Priorité de l'article d'aide (Utile lorsqu'un utilisateur possède plusieurs groupes de permission)",
    IMPORT_CODE_DESC: 'Un code doit être fourni pour pouvoir ajouter des groupes de permissions aux utilisateurs lors de leur importation',
    EMPLOYEE_PORTAL_PERMISSION_GROUP: 'Portail employé',
    SEE_EMPLOYEE_PORTAL: 'Voir le portail employé',
    ACKNOWLEDGE_LEAVE: `Marquer les requêtes d'absence comme reçues`,
    JUSTIFY_LEAVE: `Marquer les requêtes d'absence comme justifiées ou non justifiées`
  }
}
